import type { ResolutionEnvelope } from "./types";
import { qyooExperienceManifestSchema } from "../../src/manifest/schema";

export function qurl(id: number): string {
  if (!Number.isSafeInteger(id) || id < 0 || id > 68719476735) throw new Error("Invalid Qyoo ID");
  return `https://qyoo.com/q/${id}`;
}

export function installQyooContext(search: string): { id?: number; invalid: boolean } {
  const values = new URLSearchParams(search).getAll("qyoo");
  if (values.length === 0) return {invalid: false};
  const value = values[0]!;
  if (values.length !== 1 || !/^(0|[1-9][0-9]{0,10})$/.test(value) || Number(value) > 68719476735) return {invalid:true};
  return {id:Number(value), invalid:false};
}

/** Readiness comes from canonical chain-1 resolution, never a static example. */
export function isPublicExperienceReady(value: ResolutionEnvelope | null, id: number, carrierQyoob = false): boolean {
  if (!value || value.qyoo !== id || value.chain?.id !== 1 || value.blockchain?.minted !== true || value.resolution?.status !== "resolved" || value.experience?.qyoo !== id) return false;
  const parsed = qyooExperienceManifestSchema.safeParse(value.experience);
  if (!parsed.success) return false;
  if (!carrierQyoob) return true;
  const manifest = parsed.data;
  return manifest.schema === "qyoo.experience/2" && manifest.experience.type === "ar" &&
    manifest.experience.content.type === "proceduralComponent" && manifest.experience.content.component === "qyoo.qyoob/1" &&
    manifest.experience.anchor.attachmentMode === "carrierAttached";
}
